const DEFAULT_ERROR_MESSAGE =
  'An unexpected problem has occurred. Please try again.';
const NO_GROUP_FOUND_ERROR_MESSAGE = 'No group found for data entered.';

export default { DEFAULT_ERROR_MESSAGE, NO_GROUP_FOUND_ERROR_MESSAGE };
